export default __webpack_public_path__ + "44c735a95a298743e8566ba8f9c7f671.png";